import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const productBusinessManagementRoutes: RouteConfig[] = [
  {
    path: "/productBusinessManagement",
    component: Layout,
    redirect: "/productBusinessManagement",
    name: "productBusinessManagement",
    meta: {
      title: "productBusinessManagement",
      icon: "el-icon-s-goods",
      alwaysShow: true
    },
    children: [
      {
        // 表格
        path: "/productCategoryManagement",
        name: "productCategoryManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/product-hierarchy-management/list.vue"
            ),
        meta: { title: "productCategoryManagement" }
      },
      {
        // 表格
        path: "/hqSnManagement",
        name: "hqSnManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/hq-product-hierarchy-management/list.vue"
            ),
        meta: { title: "hqSnManagement" }
      },
      {
        // 表格
        path: "/productSystemManagement",
        name: "productSystemManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/product-hierarchy-management/ProductSystemManagement.vue"
            ),
        meta: { title: "productSystemManagement" }
      },
      {
        path: "/productNumberManagement",
        name: "ProductNumberManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/product-hierarchy-management/number/index.vue"
            ),
        meta: { title: "productNumberManagement", hidden: true }
      }, {
        path: "/hqProductNumberManagement",
        name: "hqProductNumberManagement",
        component: () =>
          import(
            "@/views-oms/product-business-management/hq-product-hierarchy-management/number/index.vue"
            ),
        meta: { title: "hqProductNumberManagement", activeMenu: "/hqSnManagement", hidden: true }
      },
      {
        path: "/productNumberUnitList",
        name: "ProductNumberUnitList",
        component: () =>
          import(
            "@/views-oms/product-business-management/product-hierarchy-management/number/unit/index.vue"
            ),
        meta: { title: "productNumberUnitList", hidden: true }
      },
      {
        path: "/hqProductNumberUnitList",
        name: "hqProductNumberUnitList",
        component: () =>
          import(
            "@/views-oms/product-business-management/hq-product-hierarchy-management/number/unit/index.vue"
            ),
        meta: { title: "hqProductNumberUnitList",activeMenu: "/hqSnManagement", hidden: true }
      }
      // {
      //   path: "/productNumberUnitMove",
      //   name: "ProductNumberUnitMove",
      //   component: () =>
      //     import(
      //       "@/views-oms/product-business-management/product-hierarchy-management/number/unit/move.vue"
      //     ),
      //   meta: { title: "ProductNumberUnitMove", hidden: true },
      // },
    ]
  }
];

export default productBusinessManagementRoutes;
